import { useEffect, useRef, useState } from "react";
import styles from './createMenu.module.scss';
import { ICategory } from "../../../../../../../Interfaces/responseTypes";
import { useGeneralHooks } from "../../../../../../../Hooks/hooks";

const useCreateMenuHooks = (categories: ICategory[], menuLength: number) => {
  const [showCategories, setShowCategories] = useState<boolean>(menuLength < 3);
  const [categoryHeight, setCategoryHeight] = useState<number>(0);
  const { mediumScreen } = useGeneralHooks()
  const categoryItemsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      const categoryElement = document.querySelector(`.${styles.categoryContainer}`);
      if (categoryElement) {
        mediumScreen
          ?
          setCategoryHeight(categoryElement.getBoundingClientRect().height - 5)
          :
          setCategoryHeight(categoryElement.getBoundingClientRect().height - 5);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [categories, showCategories,mediumScreen]);
  
  const onShowCategories = () => {
    setShowCategories(prev => !prev)
  }

  return {
    showCategories,
    onShowCategories,
    categoryHeight,
    categoryItemsRef
  }
};

export default useCreateMenuHooks